import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    MarkdownContent,
    Section,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { durationToHoursAndMinutes } from 'wanderu-utils';

import cgConfig from '../../../../config/carrierguide.locale';

import styles from './TopRoutes.scss';

function RouteRow(props) {
    const {
        t,
        i18nMoment,
        i18nMoney,
        route = {},
    } = props;
    const {
        arrive_city: arriveCity,
        depart_city: departCity,
        c2c_url_slug: c2cUrl,
        min_price_usd: minPrice,
        trips_per_day: tripsPerDay,
        avg_duration_seconds: duration,
    } = route;

    const tripDuration = i18nMoment.duration(duration, 'seconds');

    return (
        <TableRow>
            <TableCell size="small">
                <A href={c2cUrl}>
                    {t('routeTableLabel', { arriveCity, departCity })}
                </A>
            </TableCell>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                }}
            >
                {tripsPerDay}
            </Typography>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                }}
            >
                {t('baseApp:trip-duration_hours', durationToHoursAndMinutes(tripDuration))}
            </Typography>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                }}
            >
                {i18nMoney(minPrice).format({
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                })}
            </Typography>
        </TableRow>
    );
}

const LocalizedRouteRow = localize(RouteRow, cgConfig.namespace);

function TopRoutes(props) {
    const {
        t,
        topRoutes,
    } = props;

    const headerProps = {
        variant: 'head',
        size: 'small',
    };

    return (
        <Section
            className={styles.container}
            id="top-routes-section"
        >
            <Typography
                className={styles.title}
                component="h2"
                variant="h3"
            >
                {t('popularTripsTitle')}
            </Typography>
            <Typography
                className={styles.description}
                component={MarkdownContent}
                paragraph
            >
                {t('popularTripsDescription')}
            </Typography>
            <Typography
                className={styles.tableTitle}
                component="h3"
                variant="subtitle"
            >
                {t('popularTableTitle')}
            </Typography>
            <Table variant="blocks">
                <TableHead>
                    <TableRow variant="head">
                        <Typography
                            component={TableCell}
                            componentProps={headerProps}
                        >
                            {t('routeTableHeader')}
                        </Typography>
                        <Typography
                            component={TableCell}
                            componentProps={headerProps}
                        >
                            {t('tripsTableHeader')}
                        </Typography>
                        <Typography
                            component={TableCell}
                            componentProps={headerProps}
                        >
                            {t('durationTableHeader')}
                        </Typography>
                        <Typography
                            component={TableCell}
                            componentProps={headerProps}
                        >
                            {t('priceTableHeader')}
                        </Typography>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {topRoutes.map((route) => (
                        <LocalizedRouteRow
                            key={route?.c2c_id}
                            route={route}
                        />
                    ))}
                </TableBody>
            </Table>
        </Section>
    );
}

TopRoutes.propTypes = {
    topRoutes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export {
    RouteRow,
    TopRoutes,
};
export default localize(TopRoutes, cgConfig.namespace);
